module.exports = __webpack_public_path__ + "static/media/ArrowUp.68dc771f.svg";